import viagsApiDev from "../../pages/chats/api/axiosClientdev";

export interface VacationPersonalParams {
  year: number;
  hrId: number;
}

export interface VacationPersonalLeaveRequest {
  VReg_ID: number;
  FromDate: string;
  ToDate: string;
  Quantity: number;
  ApproveStatus: string;
  IsApproved: boolean;
}

export interface VacationPersonalData {
  HR_ID: number;
  HR_No: string;
  FullName: string;
  LeaveRequests: VacationPersonalLeaveRequest[];
  TotalApproved: number;
  TotalPending: number;
  PhepTon: number;
  OvertimeTon: number;
}

export interface VacationPersonalResponse {
  StatusCode: number;
  Message: string;
  TotalRecord: number;
  Data: VacationPersonalData;
}

export class VacationPersonalService {
  static async getPersonalVacation(params: VacationPersonalParams) {
    const response = await viagsApiDev.get<VacationPersonalResponse>("/api/vacationpersonal/vacation-get-personal", {
      params,
    });

    return response.data;
  }
}
